"use strict";
/* eslint-disable max-lines */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeConfiguration = exports.ThemeConfigurationBannerIntoModal = exports.ThemeConfigurationModalOnly = exports.ThemeConfigurationBannerOnly = exports.SharedTopLevelTheme = exports.ButtonTheme = exports.SecondLayerTheme = exports.FirstLayerTheme = exports.CommonLayerTheme = exports.ToggleTheme = exports.ContentLayout = exports.FullWidthContentLayout = exports.PaddedContentLayout = exports.FooterTheme = exports.DescriptionTextTheme = exports.CloseButtonTheme = exports.HeaderTheme = exports.ContainerTheme = exports.Breakpoint = exports.Icon = exports.Link = exports.Text = exports.Border = exports.Background = exports.ButtonThemeIndex = exports.RgbHexString = exports.RgbaHexString = exports.CssUnitString = exports.BreakpointType = exports.ContentFlows = exports.LogoPosition = exports.HorizontalAlign = exports.VerticalAlign = void 0;
const t = __importStar(require("io-ts"));
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Types representing the consent UI theme configuration
 * Includes keys for alignment, logo position, content flow, colors, and more
 */
/**
 * Vertical alignment options for the consent UI content
 */
exports.VerticalAlign = (0, type_utils_1.makeEnum)({
    /** Aligns the UI content at the top */
    Top: 'top',
    /** Aligns the UI content at the bottom */
    Bottom: 'bottom',
    /** Aligns the UI content in the center */
    Center: 'center',
});
/**
 * Horizontal alignment options for the consent UI content
 */
exports.HorizontalAlign = (0, type_utils_1.makeEnum)({
    /** Aligns the UI content on the left */
    Left: 'left',
    /** Aligns the UI content in the center */
    Center: 'center',
    /** Aligns the UI content on the right */
    Right: 'right',
});
/**
 * Position options for the logo in the consent UI
 */
exports.LogoPosition = (0, type_utils_1.makeEnum)({
    /** Logo is positioned above the content */
    Above: 'above',
    /** Logo is positioned to the left of the content */
    Left: 'left',
});
/**
 * Defines how content can flow in a layout
 */
exports.ContentFlows = (0, type_utils_1.makeEnum)({
    /** Items are stacked vertically, top to bottom */
    Vertical: 'vertical',
    /** Items are stacked horizontally, often wrapping if space runs out */
    HorizontalStacked: 'horizontal-stacked',
    /** Items are laid out horizontally, in a single row */
    HorizontalFlat: 'horizontal-flat',
});
/**
 * Units available for responsive breakpoints.
 */
exports.BreakpointType = (0, type_utils_1.makeEnum)({
    /** Breakpoint defined in pixels */
    Px: 'px',
    /** Breakpoint defined as a percentage */
    Percent: 'percent',
});
/** String that represents a CSS unit eg. px, em, etc. */
exports.CssUnitString = t.string;
/**
 * String that represents an RGBA hex color (8-digit hex with alpha channel),
 * e.g. "#FFFFFFFF" (opaque white) or "#FF000080" (semi-transparent red).
 */
exports.RgbaHexString = t.string;
/**
 * String that represents an RGB hex color (6-digit hex without alpha channel),
 * e.g. "#FFFFFF" (white) or "#000000" (black).
 */
exports.RgbHexString = t.string;
/** Index of a button's theme */
exports.ButtonThemeIndex = t.number;
/** Represents background color configuration */
exports.Background = t.type({
    /** Background color as an RGBA hex string */
    backgroundColor: exports.RgbaHexString,
});
/**
 * Represents border configuration
 */
exports.Border = t.type({
    borderRadius: exports.CssUnitString,
    borderColor: exports.RgbHexString,
});
/**
 * Represents text configuration
 */
exports.Text = t.type({
    textColor: exports.RgbHexString,
});
/**
 * Represents link configuration
 */
exports.Link = t.type({
    linkColor: exports.RgbHexString,
    linkUnderline: t.boolean,
});
/**
 * Represents icon configuration
 */
exports.Icon = t.type({
    iconColor: exports.RgbHexString,
});
/** Represents a responsive breakpoint with value and unit */
exports.Breakpoint = t.type({
    /** The numeric value of the breakpoint */
    value: t.number,
    /** The unit of the breakpoint (px or percent) */
    unit: (0, type_utils_1.valuesOf)(exports.BreakpointType),
});
/**
 * Represents a container theme with background and border configurations
 */
exports.ContainerTheme = t.intersection([exports.Background, exports.Border]);
/** Represents the header theme configuration */
exports.HeaderTheme = t.intersection([
    exports.Text,
    t.type({ logoPosition: (0, type_utils_1.valuesOf)(exports.LogoPosition) }),
]);
/** Represents the configuration of the close button */
exports.CloseButtonTheme = t.intersection([
    exports.Background,
    exports.Border,
    t.type({ iconColor: exports.RgbHexString }),
]);
/** Represents the configuration of the description text */
exports.DescriptionTextTheme = t.intersection([exports.Text, exports.Link]);
/** Represents the configuration of the footer */
exports.FooterTheme = t.intersection([
    exports.Background,
    t.type({ localePickerColor: exports.RgbHexString }),
]);
/** Defines how content should be padded and sized at different breakpoints */
exports.PaddedContentLayout = t.type({
    breakpoint: exports.Breakpoint,
    maxWidths: t.record((0, type_utils_1.valuesOf)(exports.ContentFlows), exports.CssUnitString),
});
/** Defines a layout that stretches content to full width */
exports.FullWidthContentLayout = t.type({
    fullWidth: t.literal(true),
});
/** Represents either a padded content layout or a full-width layout */
exports.ContentLayout = t.union([
    exports.PaddedContentLayout,
    exports.FullWidthContentLayout,
]);
/** Theme configuration for the toggle */
exports.ToggleTheme = t.intersection([
    exports.Text,
    exports.Icon,
    t.type({
        enabledColor: exports.RgbHexString,
        disabledColor: exports.RgbHexString,
        knobColor: exports.RgbHexString,
    }),
]);
/** Theme configuration shared between both First (banner) and Second Layers (modal) */
exports.CommonLayerTheme = t.intersection([
    t.type({
        buttons: t.tuple([
            exports.ButtonThemeIndex,
            t.union([exports.ButtonThemeIndex, t.undefined]),
            t.union([exports.ButtonThemeIndex, t.undefined]),
        ]),
        container: exports.ContainerTheme,
        description: exports.DescriptionTextTheme,
        footer: exports.FooterTheme,
        alwaysShowScrollbar: t.boolean,
        horizontalAlign: (0, type_utils_1.valuesOf)(exports.HorizontalAlign),
        cookieAndPrivacyPolicy: t.partial(exports.Link.props),
    }),
    t.partial({
        background: exports.Background,
        header: exports.HeaderTheme,
        closeButton: exports.CloseButtonTheme,
    }),
]);
/** Theme configuration for the First Layer (banner) */
exports.FirstLayerTheme = t.intersection([
    exports.CommonLayerTheme,
    t.type({
        contentFlow: (0, type_utils_1.valuesOf)(exports.ContentFlows),
        verticalAlign: (0, type_utils_1.valuesOf)(exports.VerticalAlign),
    }),
]);
/** Theme configuration for the Second Layer (modal) */
exports.SecondLayerTheme = t.intersection([
    exports.CommonLayerTheme,
    t.type({
        modalTitle: exports.Text,
        modalSubtitle: exports.Text,
        purposeListTitle: exports.Text,
        caretIcon: exports.Icon,
        cardTitle: exports.Text,
        alwaysOnText: exports.Text,
        purposeDescription: exports.DescriptionTextTheme,
        purposeCard: exports.ContainerTheme, // border color applies to dividers
        toggle: exports.ToggleTheme,
        // lockToEdges is linked to horizontalAlign left/right. if left/right, this is forced to true.
        // if horizontalAlign is center and lockEdges is true then top and bottom are locked to edges
        lockToEdges: t.boolean,
        maxWidth: exports.CssUnitString,
    }),
    t.partial({
        bulkActionButtons: t.tuple([exports.ButtonThemeIndex, exports.ButtonThemeIndex]),
        shrinkToFullWidth: exports.CssUnitString,
    }),
]);
/** Represents a button theme which can be either a full button or a link style */
exports.ButtonTheme = t.union([
    t.intersection([exports.Background, exports.Border, exports.Text]),
    exports.Link,
]);
/** Configuration shared between all themes types */
exports.SharedTopLevelTheme = t.type({
    buttonThemes: t.array(exports.ButtonTheme),
});
/** Banner-only theme configuration */
exports.ThemeConfigurationBannerOnly = t.intersection([
    exports.SharedTopLevelTheme,
    t.type({
        firstLayer: exports.FirstLayerTheme,
    }),
]);
/** Modal-only theme configuration */
exports.ThemeConfigurationModalOnly = t.intersection([
    exports.SharedTopLevelTheme,
    t.type({
        secondLayer: exports.SecondLayerTheme,
    }),
]);
/** Banner into modal theme configuration */
exports.ThemeConfigurationBannerIntoModal = t.intersection([
    exports.SharedTopLevelTheme,
    t.type({
        firstLayer: exports.FirstLayerTheme,
        secondLayer: exports.SecondLayerTheme,
    }),
]);
/** Union of all theme configurations */
exports.ThemeConfiguration = t.union([
    exports.ThemeConfigurationBannerOnly,
    exports.ThemeConfigurationModalOnly,
    exports.ThemeConfigurationBannerIntoModal,
]);
/* eslint-enable max-lines */
//# sourceMappingURL=consentUiTheme.js.map